import * as React from 'react'

import { Box, Dot, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  workable: boolean
}

const ClockedIn = ({ workable }: Props) => {
  return (
    <Box
      flexDirection="row"
      alignItems="center"
      justifyContent="spaceAround"
      background="grey400"
      width="s96"
      paddingX="s16"
      paddingY="s8"
      borderRadius={{
        all: 'abs004',
      }}
      border={{
        all: {
          color: 'lighter000',
          width: 's2',
          style: 'solid',
        },
      }}
      style={{ maxWidth: '100px' }}
    >
      <Box paddingRight="s6">
        <Dot type={workable ? 'correct' : 'warning'} blinking />
      </Box>
      <Text.Normal size="200" ellipsis>
        {i18n.t('clock_in.table.clocked_in.now')}
      </Text.Normal>
    </Box>
  )
}

export default ClockedIn
